let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("5fcII")).then(() => parcelRequire('2hPD4'));